export const BACKEND_URL = "https://attendance.testing.videekovanilla.com";
